import { UnitOfMeasure } from "src/app/models/Enums";
import {
  ParcelDimensionsOptionsByUnitOfMeasure,
  ParcelDimensionsOptionType,
} from "src/app/models/ParcelDimensionsOption";

// We need to add string type for parcelType here, because we need to use Object keys as argument in the function,
// and Object keys are always strings
export function getDimensionsLabel(
  parcelType: ParcelDimensionsOptionType | string,
  unitOfMeasure: UnitOfMeasure,
) {
  const dimensions = ParcelDimensionsOptionsByUnitOfMeasure[unitOfMeasure][parcelType];
  if (!dimensions) return "";

  return `${dimensions.length} x ${dimensions.width} x ${dimensions.height}`;
}
